import { Icon, IconProps } from '@chakra-ui/react';

export function ArrowOutward(props: IconProps): JSX.Element {
  return (
    <Icon
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.41659 4.58337V6.25004H12.5749L4.58325 14.2417L5.75825 15.4167L13.7499 7.42504V14.5834H15.4166V4.58337H5.41659Z"
        fill="currentColor"
      />
    </Icon>
  );
}
